"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What does an OEM marking program from Evermark include?",
  answer: "Evermark Industrial Solutions holds an approved first article — layout, material, fonts, and serialization — and produces equipment nameplates, data plates, and direct part marking to that standard on a recurring basis, reordered against the OEM's production schedule."
}, {
  question: "Can Evermark produce private-label or branded nameplates for our products?",
  answer: "Yes — Evermark Industrial Solutions produces nameplates carrying the OEM's branding and product identity for application to the OEM's own equipment, from the OEM's supplied artwork and specification."
}, {
  question: "How does Evermark keep marking consistent across production runs?",
  answer: "Evermark Industrial Solutions locks the approved first article and produces every release to it, so material, layout, and placement are identical run after run, with changes revision-controlled."
}, {
  question: "Can you serialize and mark traceability data on every unit?",
  answer: "Yes — Evermark Industrial Solutions marks sequential and variable serial numbers, 2D data matrix codes, and unique identifiers from your supplied sequence, supporting unit-level traceability."
}, {
  question: "Can Evermark mark to UL, MIL-STD-130, or MIL-SPEC requirements on our products?",
  answer: "Evermark Industrial Solutions produces marking designed to align with standards such as UL/ETL marking conventions, MIL-STD-130, and MIL-SPEC nameplate standards when properly specified; Evermark produces the marking and does not certify the product or confer a listing, which depends on the OEM's product and the governing authority."
}, {
  question: "What volumes and lead times do OEM programs run at?",
  answer: "Evermark Industrial Solutions sets program minimums, per-release quantities, and lead times with each OEM at setup — see {{verify: program minimums / lead times}}."
}];
export default function OemMarkingProgramsCommonQuestions() {
  return <section id="oem-marking-programs-common-questions" className="bg-card-foreground text-popover-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="font-default text-3xl md:text-4xl font-bold mb-10 text-center">
          OEM Marking Programs — Common Questions
        </h2>
        
        <Accordion type="single" collapsible className="w-full [&_svg]:text-popover-foreground">
          {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index} className="border-popover-foreground/20">
              <AccordionTrigger className="text-left text-base md:text-lg font-semibold hover:no-underline hover:text-primary transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-popover-foreground/80 text-base leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}